export default "__VITE_ASSET__9573415b__"